namespace GeniuzPOS.ReportMasterData {
    export interface Report_1414Row {
        Id?: string;
        DocDate?: string;
        BrandCode?: string;
        BrandName?: string;
        Qty?: number;
        GrossSales?: number;
        AllItemDiscount?: number;
        NetSales?: number;
        NetSalesExVat?: number;
        VatOfNetSales?: number;
        FullName?: string;
    }

    export namespace Report_1414Row {
        export const idProperty = 'Id';
        export const nameProperty = 'BrandCode';
        export const localTextPrefix = 'ReportMasterData.Report_1414';
        export const deletePermission = '1POSBASE:รายงาน:สรุปยอดขาย:รายวัน:ยอดขายรวมร้านค้า:View';
        export const insertPermission = '1POSBASE:รายงาน:สรุปยอดขาย:รายวัน:ยอดขายรวมร้านค้า:View';
        export const readPermission = '1POSBASE:รายงาน:สรุปยอดขาย:รายวัน:ยอดขายรวมร้านค้า:View';
        export const updatePermission = '1POSBASE:รายงาน:สรุปยอดขาย:รายวัน:ยอดขายรวมร้านค้า:View';

        export declare const enum Fields {
            Id = "Id",
            DocDate = "DocDate",
            BrandCode = "BrandCode",
            BrandName = "BrandName",
            Qty = "Qty",
            GrossSales = "GrossSales",
            AllItemDiscount = "AllItemDiscount",
            NetSales = "NetSales",
            NetSalesExVat = "NetSalesExVat",
            VatOfNetSales = "VatOfNetSales",
            FullName = "FullName"
        }
    }
}
